export const SERVER_URL =
  "https://dreamforce-backend-nodejs-895924407291.us-central1.run.app/user";
